<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/img/logo.png" /> -->
  <!--hero section start-->
  
  <section class="banner pos-r fullscreen-banner dark-bg p-0" data-bg-img="images/pattern/02.png">
    <div class="hero-animation"> <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="hero-text"> <span>A</span>
      <span>G</span>
      <span>E</span>
      <span>N</span>
      <span>C</span>
      <span>I</span>
      <span>O</span>
    </div>
    <div class="align-center pt-0 b-pl">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-5">
            <div class="bnr-title large">A.</div>
          </div>
          <div class="col-lg-7">
            <div class="bnr-title text-lg-left letter-space-1">Creative Agency</div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero-left h-100 d-flex align-items-center justify-content-center">
      <div class="hero-social text-center">
        <ul class="list-unstyled">
          <li>
            <a href="#"> <i class="fab fa-facebook-f"></i>
            </a>
          </li>
          <li>
            <a href="#"> <i class="fab fa-dribbble"></i>
            </a>
          </li>
          <li>
            <a href="#"> <i class="fab fa-skype"></i>
            </a>
          </li>
          <li>
            <a href="#"> <i class="fab fa-linkedin-in"></i>
            </a>
          </li>
        </ul>
      </div> <a href="#main-page" class="scroll-down-arrow"></a>
    </div>
  </section>
<!--body content start-->

<div id="main-page" class="page-content">

<!--service start-->

<section class="pos-r">
  <div class="bg-effect">
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 288 288">
      <path fill="#e1fdf5" d="">
        <animate repeatCount="indefinite" attributeName="d" dur="5s" values="M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
  c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
  c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
  c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z;  
  M51,171.3c-6.1-17.7-15.3-17.2-20.7-32c-8-21.9,0.7-54.6,20.7-67.1c19.5-12.3,32.8,5.5,67.7-3.4C145.2,62,145,49.9,173,43.4
  c12-2.8,41.4-9.6,60.2,6.6c19,16.4,16.7,47.5,16,57.7c-1.7,22.8-10.3,25.5-9.4,46.4c1,22.5,11.2,25.8,9.1,42.6
  c-2.2,17.6-16.3,37.5-33.5,40.8c-22,4.1-29.4-22.4-54.9-22.6c-31-0.2-40.8,39-68.3,35.7c-17.3-2-32.2-19.8-37.3-34.8
  C48.9,198.6,57.8,191,51,171.3z;  
  M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45
  c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2
  c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7
  c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z  " />
      </path>
    </svg>
  </div>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 z-index-1">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="featured-item style-1 active">
              <div class="featured-icon"> <i class="flaticon-idea"></i>
              </div>
              <div class="featured-title">
                <h5>Design</h5>
              </div>
              <div class="featured-desc">
                <p>There are many variations of Agencio of available</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mt-5 mt-md-0">
            <div class="featured-item style-1">
              <div class="featured-icon"> <i class="flaticon-histogram"></i>
              </div>
              <div class="featured-title">
                <h5>Marketing</h5>
              </div>
              <div class="featured-desc">
                <p>There are many variations of Agencio of available</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mt-5">
            <div class="featured-item style-1">
              <div class="featured-icon"> <i class="flaticon-analytics"></i>
              </div>
              <div class="featured-title">
                <h5>Data Analytics</h5>
              </div>
              <div class="featured-desc">
                <p>There are many variations of Agencio of available</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mt-5">
            <div class="featured-item style-1">
              <div class="featured-icon"> <i class="flaticon-optimization"></i>
              </div>
              <div class="featured-title">
                <h5>Optimization</h5>
              </div>
              <div class="featured-desc">
                <p>There are many variations of Agencio of available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mt-5 mt-lg-0">
        <div class="section-title">
          <h6>What We Do</h6>
          <h2 class="title">Agencio Make <span>Perfect Design</span></h2>
          <p class="text-black mb-0">Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur Agencio discovering the source behind the ubiquitous filler text</p>
        </div>
        <ul class="list-unstyled list-icon">
          <li class="mb-4"><i class="fas fa-check"></i> Creative Agency</li>
          <li class="mb-4"><i class="fas fa-check"></i> Fully Responsive</li>
          <li class="mb-4 mb-sm-0"><i class="fas fa-check"></i> Portfolio Option</li>
          <li><i class="fas fa-check"></i> Built With Animation</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!--service end-->


<!--case study start-->

<section class="py-3">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Our Work</h6>
          <h2 class="title mb-0">Explore some of our <span>latest Case Study.</span></h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="cases-slider pos-r">
          <div class="row">
            <div class="col-11">
              <div class="owl-carousel no-pb" data-items="1" data-autoplay="true">
                <div class="item">
                  <div class="cases-item">
                    <div class="cases-images">
                      <img class="img-fluid box-shadow" src="images/cases/01.jpg" alt="">
                    </div>
                    <div class="cases-desc d-sm-flex align-items-center justify-content-between">
                      <div> <span>Design</span>
                        <h3>Experience for Agency</h3>
                      </div> <a class="btn btn-white btn-sm" href="case-studies-single.html">Read Case Study <i class="fas fa-plus-square ml-2"></i></a>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div class="cases-item">
                    <div class="cases-images">
                      <img class="img-fluid box-shadow" src="images/cases/02.jpg" alt="">
                    </div>
                    <div class="cases-desc d-sm-flex align-items-center justify-content-between">
                      <div> <span>UX/UI Design</span>
                        <h3>Crafted with Love</h3>
                      </div> <a class="btn btn-white btn-sm" href="case-studies-single.html">Read Case Study <i class="fas fa-plus-square ml-2"></i></a>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div class="cases-item">
                    <div class="cases-images">
                      <img class="img-fluid box-shadow" src="images/cases/03.jpg" alt="">
                    </div>
                    <div class="cases-desc d-sm-flex align-items-center justify-content-between">
                      <div> <span>Branding</span>
                        <h3>Colibri Identity</h3>
                      </div> <a class="btn btn-white btn-sm" href="case-studies-single.html">Read Case Study <i class="fas fa-plus-square ml-2"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--case study end-->


<!--about start-->

<section class="pos-r">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-lg-6 col-12">
        <img class="img-fluid w-100 box-shadow" src="images/bg/01.jpg" alt="">
        <div class="row mt-4">
          <div class="col-sm-6 order-sm-1">
            <img class="img-fluid w-100 box-shadow" src="images/bg/02.jpg" alt="">
          </div>
          <div class="col-sm-6 mt-4 mt-sm-0">
            <div class="theme-bg p-4 box-shadow">
              <h3 class="text-white mb-0 font-w-5">20+ Years Experience of Business </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-12 mt-5 mt-lg-0 mr-auto">
        <div class="section-title">
          <h6>About US</h6>
          <h2 class="title">We are Design and Development <span>based on Agencio</span></h2>
          <p class="lead mb-0">Agencio discovering the source behind the ubiquitous filler text In seeing a sample of lorem ipsum, his interest was piqued by consectetur Agencio discovering the source behind the ubiquitous</p>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="counter">
              <div class="d-flex align-items-center">
                <div class="counter-icon ml-3"> <i class="flaticon-suitcase"></i>
                </div> <span class="count-number" data-to="900" data-speed="4000">900</span>
              </div>
              <h6>Lot's Of Work Completed</h6>
            </div>
          </div>
          <div class="col-sm-6 mt-5 mt-sm-0">
            <div class="counter">
              <div class="d-flex align-items-center">
                <div class="counter-icon ml-3"> <i class="flaticon-trophy"></i>
                </div> <span class="count-number" data-to="400" data-speed="4000">400</span>
              </div>
              <h6>Best Awards Winning</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--about end-->


<!--team start-->

<section class="py-3 pos-r">
  <div class="dot-bg">
    <img class="img-fluid" src="images/pattern/04.png" alt="">
  </div>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Expert Team</h6>
          <h2 class="title mb-0">Meet Our Expert will ready <span>for your service</span></h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="team-member">
          <h5><a href="team-single.html">Jesson<br>Mart</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/01.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="team-member">
          <h5><a href="team-single.html">Michael<br>Vegas</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/02.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="team-member">
          <h5><a href="team-single.html">Charlote<br>Kerry</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/03.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--team end-->


<!--testimonial start-->

<section class="pb-3">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="owl-carousel no-pb" data-dots="false" data-nav="true" data-items="1" data-autoplay="true">
          <div class="item">
            <div class="testimonial" data-bg-img="images/pattern/03.png">
              <div class="testimonial-img" data-bg-img="images/testimonial/01.jpg">
                <img class="img-fluid" src="images/testimonial/01.jpg" alt="">
              </div>
              <div class="testimonial-content">
                <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                <p>Eeque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</p>
                <div class="testimonial-caption">
                  <h5>Alvi Miller</h5>
                  <label>Founder of Agencio</label>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="testimonial" data-bg-img="images/pattern/03.png">
              <div class="testimonial-img">
                <img class="img-fluid" src="images/testimonial/02.jpg" alt="">
              </div>
              <div class="testimonial-content">
                <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                <p>Reasonable porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam tempora</p>
                <div class="testimonial-caption">
                  <h5>Albert Jonson</h5>
                  <label>CEO of Agencio</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--testimonial end-->


<!--feature start-->

<section class="pos-r">
  <div id="particles-js"></div>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h6>Why Choose Us</h6>
          <h2 class="title mb-0">We’re a full-service <span>design agency</span></h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="featured-item style-2 text-center">
          <div class="featured-icon"> <i class="flaticon-ui"></i>
            <span>01</span>
          </div>
          <div class="featured-title">
            <h5>UX Design</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy surrounding the filler text Agencio</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5">
        <div class="featured-item style-2 text-center">
          <div class="featured-icon"> <i class="flaticon-domain"></i>
            <span>02</span>
          </div>
          <div class="featured-title">
            <h5>Development</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy surrounding the filler text Agencio</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="featured-item style-2 text-center">
          <div class="featured-icon"> <i class="flaticon-challenges"></i>
            <span>03</span>
          </div>
          <div class="featured-title">
            <h5>Strategy</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy surrounding the filler text Agencio</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--feature end-->


<!--blog start-->

<section class="grey-bg parallaxie" data-bg-img="images/pattern/03.png">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Blog</h6>
          <h2 class="title">Read Our <span>Latest News</span></h2>
          <p class="text-black">Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid pl-lg-0">
    <div class="row">
      <div class="col-lg-11 col-12 mr-auto ml-lg-n5">
        <div class="owl-carousel" data-items="2" data-md-items="1" data-sm-items="1" data-margin="30" data-autoplay="true">
          <div class="item">
            <div class="row no-gutters post style-2">
              <div class="col-sm-6">
                <div class="post-image h-100" data-bg-img="images/blog/01.jpg"></div>
              </div>
              <div class="col-sm-6">
                <div class="post-desc">
                  <div class="post-meta">
                    <ul class="list-inline">
                      <li><a href="#">Admin</a>
                      </li>
                      <li>February 08, 2020</li>
                    </ul>
                  </div>
                  <div class="post-title">
                    <h5>We Develop Digital Strategy</h5>
                  </div>
                  <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row no-gutters post style-2">
              <div class="col-sm-6">
                <div class="post-image h-100" data-bg-img="images/blog/02.jpg"></div>
              </div>
              <div class="col-sm-6">
                <div class="post-desc">
                  <div class="post-meta">
                    <ul class="list-inline">
                      <li><a href="#">Admin</a>
                      </li>
                      <li>February 08, 2020</li>
                    </ul>
                  </div>
                  <div class="post-title">
                    <h5>These guide Designing work</h5>
                  </div>
                  <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row no-gutters post style-2">
              <div class="col-sm-6">
                <div class="post-image h-100" data-bg-img="images/blog/03.jpg"></div>
              </div>
              <div class="col-sm-6">
                <div class="post-desc">
                  <div class="post-meta">
                    <ul class="list-inline">
                      <li><a href="#">Admin</a>
                      </li>
                      <li>February 08, 2020</li>
                    </ul>
                  </div>
                  <div class="post-title">
                    <h5>We're Nominated To Agency</h5>
                  </div>
                  <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</div>
<!--blog end-->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data: function () {
        return {
            hasBanner: false,
            name: "home",
        }
    }
};
</script>
